import { useEffect } from 'react'

import { useHelpActions } from '@/modules/help/store'

// Support emails link to /?support=<publicId>. On load this opens the help panel on
// that ticket's thread, then cleans the address bar so a refresh does not reopen it.
export const SupportDeepLink = () => {
  const { openTickets } = useHelpActions()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const publicId = params.get('support')
    if (!publicId) return

    openTickets(publicId)
    params.delete('support')
    const query = params.toString()
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`,
    )
  }, [openTickets])

  return null
}
